module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('PlanoScaffold', {
    attrs: {
      "datas": _vm.template
    }
  }, [_c('PlanoHeader', {
    attrs: {
      "logoUrl": _vm.logoUrl
    }
  }, [_c('fragment', {
    slot: "trailing"
  }, [_c('OutlineButton', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v("save")]), _vm._v(" "), _c('OutlineButton', {
    on: {
      "click": function($event) {
        _vm.exit();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("plano.editor.header.file.exit")))])], 1)], 1), _vm._v(" "), _c('PlanoNav', {
    attrs: {
      "exitTo": "/displayers"
    },
    on: {
      "save": _vm.save,
      "saveAs": function($event) {
        _vm.toggleModalSaveAs(true);
      }
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('TemplateForm', {
    ref: "form",
    model: {
      value: (_vm.template),
      callback: function($$v) {
        _vm.template = $$v
      },
      expression: "template"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('hr') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('PlanoEngine', {
    key: _vm.templateId || 0,
    attrs: {
      "catalogPanes": _vm.catalogPanes,
      "catalogItems": _vm.fullCatalog,
      "systemType": _vm.template.systemType.id
    },
    on: {
      "search-changed": _vm.searchChanged
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.showModalSaveAs) ? _c('ModalSaveAsTemplate', {
    attrs: {
      "template": _vm.datasTosave
    },
    on: {
      "close": function($event) {
        _vm.toggleModalSaveAs(false);
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showExitModal) ? _c('ModalExitPlano', {
    attrs: {
      "name": _vm.template && _vm.template.name,
      "readOnly": _vm.readOnly
    },
    on: {
      "save": function($event) {
        _vm.saveAfterExit($event);
      },
      "close": function($event) {
        _vm.closeExitModal();
      }
    }
  }) : _c('Loader', {
    attrs: {
      "loading": _vm.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58bea6c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/template.vue
// module id = 3202
// module chunks = 0